<template>
    <li class="menu-item-horizontal-li">
        <div class="menu-item-horizontal-wrap"
             @click="openFullItem">
            <div class="menu-item-horizontal-image-wrap"
                 :class="{ 'menu-item-horizontal-image-wrap--no-photo': !item.image }">
                <VImage v-if="item.image"
                        :src="item.image"
                        :alt="item.name" />

                <div class="menu-item-horizontal-scrim"></div>

                <div class="menu-item-horizontal-add"
                     v-if="canOrder">
                    <IconPlus />
                </div>

                <div class="menu-item-horizontal-info">
                    <div class="menu-item-horizontal-name">{{ item.name }}</div>
                    <div class="menu-item-horizontal-footer">
                        <span class="menu-item-horizontal-price">{{ item.price }} zł</span>
                    </div>
                </div>
            </div>
        </div>
        <DishDetails v-if="showFullItem"
                     ref="detailsRef"
                     v-model="showFullItem"
                     :dish-id="item.id"
                     :dish="item" />
    </li>
</template>

<script>
import IconPlus from '@/components/icons/IconPlus.vue';
import DishDetails from '@/modules/dishDetails/DishDetails.vue';
import VImage from "@/components/ui/VImage.vue";

export default {
    name: "MenuHorizontalItem",
    components: {
        IconPlus,
        DishDetails,
        VImage,
    },
    props: {
        item: { type: Object, required: true }
    },
    data() {
        return {
            showFullItem: false,
        };
    },
    computed: {
        canOrder() {
            const locale = this.$store.getters['getCompanyData'].locale;

            return (locale.activePaymentCredentials || this.$store.getters['getIsModeHOT'] || this.$store.getters['getIsModeSOT'])
                && locale.pos_terminal_enabled
                && locale.smart_menu_cart_enabled;
        },
    },
    methods: {
        openFullItem() {
            this.showFullItem = true;
            this.$nextTick(() => {
                this.$refs.detailsRef.open();
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.slide-up-enter-active {
    transition: all .4s ease;
}

.slide-up-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-up-enter,
.slide-fade-leave-to {
    transform: translateY(100vh);
    opacity: 0;
}

.menu-item-horizontal-li {
    flex-shrink: 0;
    margin-bottom: 4px;

    height: 240px;
    width: 200px;

    border-radius: 26px;

    box-shadow: var(--shadow-md);
}

.menu-item-horizontal-wrap {
    display: flex;
    flex-direction: column;

    height: 100%;
    cursor: pointer;
}

.sold {
    opacity: 50%;
}

.menu-item-horizontal-image-wrap {
    position: relative;

    width: 100%;
    height: 100%;

    border-radius: 26px;
    overflow: hidden;

    &--no-photo {
        background: var(--grad-brand);
    }

    img {
        width: 100%;
        height: 100%;

        object-fit: cover;
        display: block;
    }

    .menu-item-horizontal-scrim {
        position: absolute;
        inset: 0;
        pointer-events: none;

        background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.62) 0%,
            rgba(0, 0, 0, 0.18) 36%,
            rgba(0, 0, 0, 0) 62%
        );
    }

    .menu-item-horizontal-add {
        display: flex;
        align-items: center;
        justify-content: center;

        position: absolute;
        top: 10px;
        right: 10px;

        width: 34px;
        height: 34px;

        border-radius: 13px;

        box-shadow: var(--shadow-brand);
        background: var(--grad-brand);

        ::v-deep svg path {
            fill: #fff;
        }
    }
}


.menu-item-horizontal-info {
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: 14px;

    display: flex;
    flex-direction: column;
    gap: 4px;

    .menu-item-horizontal-name {
        font-weight: var(--weight-bold);
        font-size: 16px;
        line-height: 20px;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        color: #fff;
    }


    .menu-item-horizontal-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menu-item-horizontal-price {
            font-weight: var(--weight-bold);
            font-size: 16px;
            line-height: 1;

            color: #fff;
        }
    }
}
</style>
